import { createAction } from '@reduxjs/toolkit';

const setPush = createAction<{
  message: string;
  type: 'warning' | 'success' | 'default' | 'error';
}>('app/message');

const clearPush = createAction('app/clearPush');

export { setPush, clearPush };
